<template>
  <div style="background:#FAFAFA88" class="word_keeper" id="footer_height">
    <v-divider></v-divider>
    <v-container class="hidden-sm-and-down">
      <div class="text-right pa-2 d-flex flex-wrap" padless>       
        <div class="mr-2 mb-0 d-flex" > 
          <div>TEL : 054-630-8127</div> <div class="text-caption mt-1 ml-2">※ 방문예약시스템은 Chrome 브라우저에 최적화 되어 있습니다.</div>
        </div>
        <v-spacer />       
        <div class="grey--text font-weight-light caption">COPYRIGHT © {{ new Date().getFullYear() }} 
          <a
            href="https://www.skspecialty.com"
            style="font-weight:bolder; text-decoration:none; color:#888888;"
            target="_blank"
          >방문예약시스템 SK specialty Co.LTD</a> &nbsp;&nbsp; All right reserved.
          
          <img class="ml-2 mb-n2 mr-3" src="../../assets/main_logo_grey.svg" style="height:25px; opacity: 0.5;"/>
        </div>    
      </div>
    </v-container>
    <v-container class="hidden-md-and-up">
      <div class="text-right pa-2" padless>
        <div class="mr-2 mb-0" align="left">
          <div>TEL : 054-630-8127</div>
          <div class="text-caption mt-1 ml-2">※ 방문예약시스템은 Chrome 브라우저에 최적화 되어 있습니다.</div>
        </div>
        <div class="grey--text font-weight-light caption">COPYRIGHT © {{ new Date().getFullYear() }} 
          <a
            href="https://www.skspecialty.com"
            style="font-weight:bolder; text-decoration:none; color:#888888;"
            target="_blank"
          >방문예약시스템 SK specialty Co.LTD</a> &nbsp;&nbsp; All right reserved.
          
          <img class="ml-2 mb-n2 mr-3 mt-2" src="../../assets/main_logo_grey.svg" style="height:25px; opacity: 0.5;"/>
        </div>    
      </div>
    </v-container>
  </div>
</template>


<script>
export default {
  data: () => ({})
};
</script>

<style scoped>
  #under_bar {
    z-index: 1;
    position: relative;
    top : 0px;
    width : 100%;
    height : 0.5px;
    background:#E0E0E0;    
  }
  #core-footer {
    z-index: 0;
  }
</style>
